import { AxiosError } from 'axios';

// Logger from @smg-real-estate/lambda-middleware is not designed for hydrid app like seeker app
// We have to copy-paste the LogType from @smg-real-estate/lambda-middleware
// with the value we need for this appplication
// DevX will re-visit and see if we can have a better solution
export enum LogType {
  ApplicationConfidential = 'application-confidential',
}

function populateError(params?: Record<string, unknown>, error?: Error): Record<string, unknown> {
  if (!error) {
    return {
      ...(params ?? {}),
    };
  }

  return {
    ...(params ?? {}),
    errorName: error.name,
    errorMessage: error.message,
    stackTrace: error.stack,
  };
}

function log(
  level: 'info' | 'warn' | 'error',
  message: string,
  params?: Record<string, unknown>,
  timestamp?: Record<string, string>,
): void {
  const timestampObj = timestamp ? timestamp : { timestamp: new Date().toISOString() };
  // Manually add the logType for retention policy to work on DataDog
  const record = {
    ...timestampObj,
    level,
    message,
    logType: LogType.ApplicationConfidential,
    params,
  };
  console[level](JSON.stringify(record));
}

export const logError = (
  message: string,
  params?: Record<string, unknown>,
  error?: Error,
  timestamp?: Record<string, string>,
): void => {
  log('error', message, populateError(params, error), timestamp);
};

export const logInfo = (
  message: string,
  params?: Record<string, unknown>,
  timestamp?: Record<string, string>,
): void => {
  log('info', message, params, timestamp);
};

export const logWarn = (
  message: string,
  params?: Record<string, unknown>,
  error?: Error,
  timestamp?: Record<string, string>,
): void => {
  log('warn', message, populateError(params, error), timestamp);
};

export enum ApiTypes {
  search_api = 'search results',
  geo_api = 'geo results',
  geo_extra_api = 'geo extra results',
}

export const WARNING_LEVEL_HTTP_CODES = {
  /* 404 - Not Found, as we can not prevent requests for locations which do no exist in our system
      the case is logged as warn */
  [ApiTypes.geo_api]: [404],

  /* 404 - Not Found, e.g. listing does not exist */
  // [ApiTypes.listing_api]: [404],

  /* 416 - Requested Range Not Satisfiable, e.g. page number is too high */
  [ApiTypes.search_api]: [416],

  /* 404 - Not Found, e.g. description does not exist */
  [ApiTypes.geo_extra_api]: [404],

  //TODO: remove this once we have a better solution
  /* 404 - Not Found, e.g. regional highlight does not exist */
  // [ApiTypes.regional_highlight]: [404],
};

/**
 * All logs are ingested to Datadog.
 * The one logged by logErrorToDatadogCustomMetric is used for generating custom metrics
 *
 * @param message - The error message.
 * @param params - Additional parameters to include in the log.
 * @param error - The error object.
 */
export const logErrorToDatadogCustomMetric = (
  subject: ApiTypes,
  params?: Record<string, unknown>,
  error?: AxiosError,
): void => {
  const customMetricMessagePattern = `Failed to fetch ${subject}`;

  const statusCode = error?.response?.status;

  if (statusCode && WARNING_LEVEL_HTTP_CODES[subject]?.includes(statusCode)) {
    logWarn(customMetricMessagePattern, params, error);
  } else {
    logError(customMetricMessagePattern, params, error);
  }
};
